// extracted by mini-css-extract-plugin
export default {"page":"page__a6153232","search":"search__a6153232","tabs":"tabs__a6153232","pagination":"pagination__a6153232"};